import { Injectable } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import {
  CmsComponent,
  CmsComponentConnector,
  Country,
  PageContext,
  RoutingService,
  UserIdService
} from '@spartacus/core'
import { combineLatest, Observable } from 'rxjs'
import { filter, take } from 'rxjs/operators'
import { EbCart } from '../../../cart/interface/eb-cart.interface'
import { EbCommonFormAdapter } from '../../../support/common/services/connectors/eb-common-form.adapter'
import { EbCheckoutCommandService } from '../../commands/eb-checkout-command.service'
import { EndCustomerType } from '../../interface/eb-checkout.interface'
import { EbCheckoutAdapter } from '../connectors/eb-checkout.adapter'

@Injectable({ providedIn: 'root' })
export class EbCheckoutService {
  constructor(
    protected activeCartService: ActiveCartFacade,
    protected userIdService: UserIdService,
    protected cmsComponentConnector: CmsComponentConnector,
    protected commonFormAdapter: EbCommonFormAdapter,
    protected checkoutAdapter: EbCheckoutAdapter,
    protected ebCheckoutCommandService: EbCheckoutCommandService,
    protected routingService: RoutingService
  ) {}

  /**
   * Places an order
   */
  placeOrder(termsAndConditions: boolean, exportControlProvisions: boolean): void {
    combineLatest([this.userIdService.getUserId(), this.activeCartService.getActiveCartId()])
      .pipe(
        filter(([userId, cartId]) => !!(userId && cartId)),
        take(1)
      )
      .subscribe(([userId, cartId]) => {
        this.ebCheckoutCommandService
          .placeOrder(userId, cartId, termsAndConditions, exportControlProvisions)
          .subscribe(order => {
            if (order) {
              this.routingService.go({ cxRoute: 'orderConfirmation' })
            }
          })
      })
  }

  setDestinationCountry(
    userId: string,
    cartId: string,
    countryIsoCode: string
  ): Observable<EbCart> {
    return this.checkoutAdapter.setDestinationCountry(userId, cartId, countryIsoCode)
  }

  setTypeOfEndCustomer(userId: string, cartId: string, partnerCode: string): Observable<EbCart> {
    return this.checkoutAdapter.setTypeOfEndCustomer(userId, cartId, partnerCode)
  }

  getLinkComponentsById(ids: string[], pageContext: PageContext): Observable<CmsComponent[]> {
    return this.cmsComponentConnector.getList(ids, pageContext)
  }

  getCountries(): Observable<Country[]> {
    return this.commonFormAdapter.getCountries()
  }

  getTypesOfEndCustomer(userId: string): Observable<EndCustomerType[]> {
    return this.checkoutAdapter.getTypesOfEndCustomer(userId)
  }
}
